// import React from 'react';
// import PropTypes from 'prop-types';
// import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
// // import IntegrationReactSelectNew from '@mui/material/IntegrationReactSelectNew';
// import InputBase from '@mui/material/InputBase';
// import { purple } from '@mui/material/colors';
// import IntegrationReactSelectNew from './IntegrationReactSelectNew';



// const styles = theme => ({
//   container: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     marginTop: '0',
//     marginBottom: '0',
//     padding: '0',
//   },
//   cssLabel: {
//     '&$cssFocused': {
//       textTransform: 'uppercase',
//       fontWeight: 'bolder',
//       // color: '#00B0A9',
//     },    
//   },
//   cssFocused: {   
//   },
//   cssUnderline: {
//     '&:after': {
//       borderBottomColor: '#00B0A9',
//     },
//   },
//   IntegrationReactSelectNew: {
//     marginLeft: theme.spacing.unit,
//     marginRight: theme.spacing.unit,
//     width: '100%',  
//   },
//   dense: {
//     marginTop: 0,
//   },

  
// });


// const theme = createTheme({
//   palette: {
//     primary: { main: '#00B0A9'}, // Purple and green play nicely together.
//     secondary: { main: '#11cb5f' }, // This is just green.A700 as hex.
//   },  
//   typography: { useNextVariants: true },
//   notchedOutline:{
//     width: '50%',
//     border: 'red 2px solid'
//   }


// });



// class MaterialUIMultiLine extends React.Component {
//   state = {
//     name: 'Cat in the Hat',
//     age: '',
//     multiline: 'Controlled',
//     currency: 'EUR',
//   };

//   handleChange = name => event => {
//     if (this.props.limitLength && event.target.value.length < 500) {
//       this.setState({
//         [name]: event.target.value.substring(0, 499),
//       });
//       this.props.handleInputChange(name, event.target.value.substring(0, 499))
//     }
//   };

//   _handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       this.props.handeSubmitReply('dsf')
//     }
//   }


//   render() {
//     const { classes } = this.props;
//     return (
//       <ThemeProvider theme={theme}>
//         <form className={classes.container} noValidate autoComplete="off">
//           <span style={{ margin: '0% 0% -1% .75%', fontWeight: 'bolder' }} >{this.props.label === '' ? this.props.label : this.props.label}</span>
//           <IntegrationReactSelectNew
//             id="standard-multiline-static"
//             underline={false}
//             multiline
//             rows={this.props.rows || 2}
//             className={classes.IntegrationReactSelectNew}
//             margin="normal"
//             onChange={this.handleChange(this.props.name)}
//             onKeyPress={this._handleKeyPress}
//             value={this.props.inputValue}
//             disabled={this.props.disabled}
//             helperText={this.props.errorText}
//             error={this.props.error}
//             InputProps={{
//               classes: {
//                 'notchedOutline': 'whiteOutlineNotch',   
//                 'focused': 'blueOutlineNotch'                      
//               }
//             }}
//             // label={this.props.label === '' ? this.props.label : this.props.label.toUpperCase()}
//             variant="outlined"
//             inputProps={{
//               maxLength: this.props.limitLengthValue
//             }}
//           />
//         </form>
//       </ThemeProvider>
//     );
//   }
// }

// MaterialUIMultiLine.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

// export default styled(styles)(MaterialUIMultiLine);


import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const theme = createTheme({
  palette: {
    primary: { main: '#00B0A9' },
    secondary: { main: '#11cb5f' },
  },
  typography: { useNextVariants: true },
});

class MaterialUIMultiLine extends React.Component {
  state = {
    name: 'Cat in the Hat',
    age: '',
    multiline: 'Controlled',
    currency: 'EUR',
  };

  handleChange = name => event => {
    if (this.props.limitLength && event.target.value.length < 500) {
      const value = event.target.value.substring(0, 499);
      this.setState({ [name]: value });
      this.props.handleInputChange(name, value);
    } else {
      this.props.handleInputChange(name, event.target.value);
    }
  };

  _handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      this.props.handeSubmitReply('dsf');
    }
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <form
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: 0,
            marginBottom: 0,
            padding: 0,
          }}
          noValidate
          autoComplete="off"
        >
          <span style={{ margin: '0% 0% -1% .75%', fontWeight: 'bolder' }}>
            {this.props.label || ''}
          </span>
          <TextField
            id="standard-multiline-static"
            multiline
            rows={this.props.rows || 2}
            fullWidth
            sx={{ my: 1 }}
            margin="normal"
            onChange={this.handleChange(this.props.name)}
            onKeyPress={this._handleKeyPress}
            value={this.props.inputValue}
            disabled={this.props.disabled}
            helperText={this.props.errorText}
            error={this.props.error}
            variant="outlined"
            inputProps={{
              maxLength: this.props.limitLengthValue,
            }}
          />
        </form>
      </ThemeProvider>
    );
  }
}

MaterialUIMultiLine.propTypes = {
  label: PropTypes.string,
  rows: PropTypes.number,
  inputValue: PropTypes.string,
  limitLength: PropTypes.bool,
  limitLengthValue: PropTypes.number,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  error: PropTypes.bool,
  handleInputChange: PropTypes.func,
  handeSubmitReply: PropTypes.func,
  name: PropTypes.string,
};

export default MaterialUIMultiLine;

